import { request } from './util';

// VD 그룹 목록 조회
export async function getVdCreationTemplates() {
  return request({
    scope: 'portal',
    name: 'approval/get-vd-creation-templates',
    data: {
      payload: [],
    },
  });
}

// 승인업무 > 대기중 목록 조회(= 내가 결제할 목록 조회)
export async function getApprovalDocuments(payload) {
  return request({
    scope: 'portal',
    name: 'approval/get-approval-documents',
    data: payload,
  });
}

// 승인업무 > 완료 목록 조회(= 내가 결제한 목록 조회)
export async function getCompletedApprovalDocuments(payload) {
  return request({
    scope: 'portal',
    name: 'approval/get-completed-approval-documents',
    data: payload,
  });
}

// 승인 업무에서 승인/반려하기
export async function updateApprovalLine(payload) {
  return request({
    scope: 'portal',
    name: 'approval/update-approval-line',
    data: payload,
  });
}

// 할당된 네트워크 드라이브 목록 조회(= 관리자로 설정된 드라이브 목록)
export async function getAssignedDrives(payload) {
  return request({
    scope: 'portal',
    name: 'approval/get-assigned-drives',
    data: payload,
  });
}

// 네트워크 드라이브 상세 정보 조회
export async function getAssignedDriveDetail(payload) {
  return request({
    scope: 'portal',
    name: 'approval/get-assigned-drive-detail',
    data: payload,
  });
}

// 서비스 신청 목록 조회
export async function getRequestList(param) {
  const filter = { applicantForPortal: localStorage.getItem('userId') };
  // 전체인 경우 param에 ''이 들어온다.
  if (param) {
    filter.type = param;
  }
  return request({
    scope: 'portal',
    name: 'approval/get-approval-documents',
    data: {
      paging: { filter },
    },
  });
}

export async function getRequestDetail(id) {
  return request({
    scope: 'portal',
    name: 'approval/get-approval-detail',
    data: {
      approvalId: id,
    },
  });
}

export async function requestApproval(payload) {
  return request({
    scope: 'portal',
    name: 'approval/request-approval',
    data: {
      ...payload,
    },
  });
}

export async function changeStateOfApproval(payload) {
  return request({
    scope: 'portal',
    name: 'approval/update-approvals-state',
    data: {
      ...payload,
    },
  });
}

export async function updateApproval(id, params) {
  return request({
    scope: 'portal',
    name: 'approval/update-approval',
    data: {
      approvalId: id,
      ...params,
    },
  });
}

export async function getFlavors() {
  return request({
    scope: 'portal',
    name: 'approval/get-flavor',
    data: { paging: { params: {}, sorter: {} } },
  });
}

// 서비스 신청 코멘트 조회
export async function getApprovalComments(id) {
  return request({
    scope: 'portal',
    name: 'approval/get-approval-comment',
    data: {
      id,
    },
  });
}

// 서비스 신청 코멘트 저장
export async function saveApprovalComment(id, comment) {
  return request({
    scope: 'portal',
    name: 'approval/update-approval-comment',
    data: {
      id,
      comment,
    },
  });
}

// 서비스 신청 타입별 최종 결재선 조회
export async function getApprovalLinesByType(type) {
  return request({
    scope: 'portal',
    name: 'approval/get-approval-final-line',
    data: {
      type,
    },
  });
}
